import http from '@/http'
const URL = '/admin/rooms'

export const list = async (params) => {
  const list = (await http.get(URL + `/${params.room_id}/streamings`, { params: params }))
  return list
}

export const find = async (params) => {
  let one = null
  if (params.id) {
    one = (await http.get(URL + `/${params.room_id}/streamings/${params.id}`))
  }
  return one
}

export const save = (payload) => {
  let id = payload.id || ''
  return http.post(URL + `/${payload.room_id}/streamings/${id}`, payload)
}

export const deleteStreaming = async (payload) => http.delete(URL + `/${payload.room_id}/streamings/${payload.id}`)
export const changeStatus = (payload) => http.put(URL + `/${payload.room_id}/streamings/${payload.id}/status`, payload)

export default {
  list,
  find,
  save,
  changeStatus,
  deleteStreaming
}
